import React from 'react'
import TextInput from '../../../Input/Text'
import TextArea from '../../../Input/TextArea'
import MultiSelect from '../../../Input/Relation/MultiSelect'
import validate from './lib/validate'

const getNewOptionData = (email) => ({
  email,
  name: email,
  __isNew__: true,
})

const getOptionValue = ({ email }) => email

export default () => (
  <>
    <MultiSelect
      isCreatable
      label='Recipients'
      name='recipients'
      getNewOptionData={getNewOptionData}
      getOptionValue={getOptionValue}
    />
    <TextInput label='Subject' name='subject' validate={validate('subject')} />
    <TextArea label='Text' name='text' validate={validate('text')} />
  </>
)
